const features = [
  {
    icon: 'ri-scissors-cut-line',
    title: '分割',
    description:
      '指定したページ数ごとにPDFを分けます。\n分割後のファイル名（すべて）を事前に設定することもできます。'
  },
  {
    icon: 'ri-export-line',
    title: '抽出',
    description:
      '必要なページだけを取り出して、新しいPDFとして保存します。\n入力した順番でページが並ぶため、ページの入れ替えのように使うこともできます。\nページ指定例：1,3,5-7、3,1,5'
  },
  {
    icon: 'ri-git-merge-line',
    title: '結合',
    description:
      '複数のPDFを、リストの順番どおりに1つにまとめます。\nドラッグ&ドロップでの追加にも対応しています。',
  },
];

const HitotsuzuriFeatures = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Features
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
            できること
          </h4>
        </div>
        <div className="space-y-6 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-5 bg-[#F8FBF6] rounded-xl p-6 md:p-8"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#5DAA68]/10 shrink-0">
                <i className={`${feature.icon} text-xl text-[#5DAA68]`}></i>
              </div>
              <div className="flex-1">
                <h5 className="text-base font-bold text-[#89B56B] mb-2">
                  {feature.title}
                </h5>
                <p className="text-[13px] text-gray-600 leading-relaxed whitespace-pre-line">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(137,181,107,0.08)]">
            <img
              src="/image/hitotsuzuri-light.png"
              alt="一綴り ライトモード"
              title="一綴り PDFツール ライトモード"
              className="w-full h-[200px] sm:h-[240px] md:h-[280px] object-contain md:object-cover object-top"
            />
            <div className="py-4 text-center">
              <p className="text-sm font-semibold text-[#89B56B]">ライトモード</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(137,181,107,0.08)]">
            <img
              src="/image/hitotsuzuri-dark.png"
              alt="一綴り ダークモード"
              title="一綴り PDFツール ダークモード"
              className="w-full h-[200px] sm:h-[240px] md:h-[280px] object-contain md:object-cover object-top"
            />
            <div className="py-4 text-center">
              <p className="text-sm font-semibold text-[#89B56B]">ダークモード</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HitotsuzuriFeatures;